module.exports = __webpack_public_path__ + "static/media/2_.1b95ade0.png";